import { z } from 'zod';
export var AthleteProfileDomain;
(function (AthleteProfileDomain) {
    AthleteProfileDomain.Module = 'AthleteProfile';
    const module = z.literal(AthleteProfileDomain.Module);
    AthleteProfileDomain.Edit = z.object({
        module,
        type: z.literal('Edit'),
        input: z.object({
            id: z.uuid(),
        }),
    });
})(AthleteProfileDomain || (AthleteProfileDomain = {}));
//# sourceMappingURL=domain.js.map